import React, { useEffect, useState } from "react";
import { ReactComponent as CallIcon } from "./../../assets/images/icons/Google SVGs/call.svg";
import { ReactComponent as LocationOnIcon } from "./../../assets/images/icons/Google SVGs/location_on.svg";
import { ReactComponent as ChatIcon } from "./../../assets/images/icons/Google SVGs/chat.svg";
import { ReactComponent as StethoscopeIcon } from "./../../assets/images/icons/Google SVGs/stethoscope.svg";
import { ReactComponent as DeleteIcon } from "./../../assets/images/icons/Google SVGs/delete.svg";
import { ReactComponent as AvgPaceIcon } from "./../../assets/images/icons/Google SVGs/avg_pace.svg";
import { ReactComponent as EnhancedEncryptionIcon } from "./../../assets/images/icons/Google SVGs/enhanced_encryption.svg";
import { ReactComponent as ChevronDownIcon } from "./../../assets/images/icons/Google SVGs/chevron_down.svg";
import { ReactComponent as ScheduleIcon } from "./../../assets/images/icons/Google SVGs/schedule.svg";
import { ReactComponent as DiversityIcon } from "./../../assets/images/icons/Google SVGs/diversity_4.svg";
import { ReactComponent as HomeHealthIcon } from "./../../assets/images/icons/Google SVGs/home_health.svg";
import { ReactComponent as VideoIcon } from "./../../assets/images/icons/Google SVGs/videocam.svg";
import { ReactComponent as ArrowLeftAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_left_alt.svg";
import { ReactComponent as MoreVertIcon } from "./../../assets/images/icons/Google SVGs/more_vert.svg";
import { ReactComponent as EditIcon } from "../../assets/images/icons/Google SVGs/edit.svg";
import { ReactComponent as PlaylistRemoveIcon } from "./../../assets/images/icons/Google SVGs/playlist_remove.svg";

const VacationCard = (props) => {
  useEffect(() => {}, []);

  return (
    <div className="card background-bootstrap-gray-100 color-bootstrap-gray-700 border border-1 border-bootstrap-gray-400 rounded-2 w-auto mb-2">
      <div className="card-body p-2 d-flex row gy-2 mx-0">
        <div className="d-flex px-0 pb-2 border-bottom">
          <div className="d-flex col flex-column rounded-1 fw-normal">
            <span className="fs-14">{props.place}</span>
            <span className="fs-12">{props.department}</span>
          </div>
          <div className="d-flex col col-auto dropdown px-0">
            <MoreVertIcon
              width={24}
              height={24}
              type="button"
              id="dropdownMenuOffset"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            />

            <ul
              className="dropdown-menu fit-dropdown py-0 w-fit"
              aria-labelledby="dropdownMenuOffset"
            >
              <li
                className="dropdown-item px-2"
                type="button"
                onClick={() => {
                  props.onEdit();
                }}
              >
                <div className="text-decoration-none fs-14 w-100 d-flex align-items-center">
                  <EditIcon width={16} className="me-1" />
                  ویرایش مرخصی
                </div>
              </li>
              <li
                className="dropdown-item px-2"
                type="button"
                onClick={() => {
                  props.onRemove();
                }}
              >
                <div className="color-bootstrap-regular-danger text-decoration-none fs-14 w-100 d-flex align-items-center">
                  <PlaylistRemoveIcon width={16} className="me-1" />
                  حذف درخواست
                </div>
              </li>
            </ul>
          </div>
        </div>

        {props.type == "daily" && (
          <div className="d-flex px-0">
            <div className="d-flex col col-6 py-1 pe-2 border-end">
              <div className="d-flex flex-column">
                <span className="color-bootstrap-gray-600 fs-14 fw-medium mb-1">
                  تاریخ شروع
                </span>
                <span className="fs-14 fw-normal color-bootstrap-gray-800">
                  {props.start}
                </span>
              </div>
            </div>

            <div className="d-flex col col-6 py-1 ps-2">
              <div className="d-flex flex-column">
                <span className="color-bootstrap-gray-600 fs-14 fw-medium mb-1">
                  تاریخ پایان
                </span>
                <span className="fs-14 fw-normal color-bootstrap-gray-800">
                  {props.end}
                </span>
              </div>
            </div>
          </div>
        )}
        {props.type == "hourly" && (
          <div className="d-flex px-0">
            <div className="d-flex col col-6 py-1 pe-2 border-end">
              <div className="d-flex flex-column">
                <span className="color-bootstrap-gray-600 fs-14 fw-medium mb-1">
                  تاریخ
                </span>
                <span className="fs-14 fw-normal color-bootstrap-gray-800">
                  {props.date}
                </span>
              </div>
            </div>

            <div className="d-flex col col-6 py-1 ps-2">
              <div className="d-flex flex-column">
                <span className="color-bootstrap-gray-600 fs-14 fw-medium mb-1">
                  ساعت
                </span>
                <span className="fs-14 fw-normal color-bootstrap-gray-800">
                  <span className="fs-14 fw-normal">{props.start}</span>
                  <ArrowLeftAltIcon width={24} height={24} className="mx-2" />
                  <span className="fs-14 fw-normal">{props.end}</span>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VacationCard;

{
  /* <div className="card border-0 bg-white w-auto mb-2">
      <div className="card-body p-2 d-flex row gy-2 mx-0">
        <hr className="my-0 color-bootstrap-gray-300 opacity-100" />

        <div className="d-flex col col-12 flex-column background-bootstrap-gray-100 rounded-1">
          <span className="fs-16 fw-normal color-bootstrap-gray-700">
            مرکز فوق تخصصی درمان ناباروری و سقط مکرر ابن سینا
          </span>
          <span className="fs-14 fw-normal color-bootstrap-gray-700">
            مشاوره و درمان مشکلات نوزادان طبیعی و نارس
          </span>
        </div>

        <div className="d-flex col col-12 flex-column background-bootstrap-gray-100 rounded-1">
          <span className="fs-16 fw-normal color-bootstrap-gray-700">
            مرکز فوق تخصصی درمان ناباروری و سقط مکرر ابن سینا
          </span>
          <span className="fs-14 fw-normal color-bootstrap-gray-700">
            مشاوره و درمان مشکلات نوزادان طبیعی و نارس
          </span>
        </div>

        <div className="d-flex col col-12 bg-iso-blue-100 color-iso-blue-200 rounded-1 py-2px">
          <span className="fs-14 fw-normal">زمان مرخصی</span>
          <div className="ms-auto">
            <span className="fs-14 fw-normal">1402/12/3</span>
            <ArrowRightAltIcon width={16} height={16} className="mx-2" />
            <span className="fs-14 fw-normal">1402/12/3</span>
          </div>
        </div>
      </div>
    </div> */
}
